import { x0, x } from '../../../_helpers';
export default class DateTimeConverter {
  constructor() {
    this.el = x0('article');
    if (!this.el) return;
    this.init();
  }

  convertUtcToLocal() {
    if (this.dateTimeElements.length > 0) {
      this.dateTimeElements.forEach((element) => {
        const dateValue = element.getAttribute('data-datetime');
        if (!dateValue) {
          return;
        }
        const utcDateTime = dateValue.concat(' UTC');
        const parsedDateTime = new Date(Date.parse(utcDateTime));
        const options = { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' }; //Format: Thursday, Apr 16, 2020 03:52 AM
        const dateTimeLocal = parsedDateTime.toLocaleDateString('en-US', options);
        element.innerHTML = dateTimeLocal;
      });
    }
  }

  init() {
    this.dateTimeElements = x('[js-date-time-to-convert]');
    this.convertUtcToLocal();
  }
}
